export default {
  sm: `
  NAVER also plans to build a new 
  data center to create values leveraged 
  by upcoming of the cloud markets and 
  emerged 5G technologies. 
  `,
  lg: `
  NAVER also plans to build a new data center to 
  create values leveraged by upcoming of the cloud 
  markets and emerged 5G technologies. 
  `,
  xxl: `
  NAVER also plans to build a new data center to create 
  values leveraged by upcoming of the cloud markets and 
  emerged 5G technologies. 
  `,
};
